<template>
  <div>
    <p class="title is-3-desktop is-4-tablet is-5-mobile">
      Lista de Materiales
    </p>

    <section>
      <a @click="cargarPedidos" class="button is-success">Consultar</a>
    </section>

    <section style="margin-top: 30px">
      <b-table
        :data="materiales"
        :hoverable="true"
        :mobile-cards="true"
        paginated
        :per-page="searchOptions.perPage"

      >
        <template slot-scope="props">
          <b-table-column label="Tipo Material" class="is-size-7">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column label="Código Barra" class="is-size-7">
            <div v-if="props.row.barCode">Si</div>
            <div v-else>No</div>
          </b-table-column>

          <b-table-column label="N° Orden" class="is-size-7">
            {{ props.row.numberOrder }}
          </b-table-column>

          <b-table-column label="Cantidad" class="is-size-7">
            {{ props.row.cantidad }}
          </b-table-column>

          <b-table-column label="Descripción" class="is-size-7">
            {{ props.row.description }}
          </b-table-column>

          <b-table-column label="Observación" class="is-size-7">
            {{ props.row.observation }}
          </b-table-column>

          <b-table-column label="N° Código Barras" class="is-size-7">
            {{ props.row.code }}
          </b-table-column>

          <b-table-column label="Acciones" class="is-size-7">
            <button
              v-if="props.row.code"
              @click="doExportReportFilesPdf(props.row)"
              class="button is-small"
            >
              <b-icon icon="file-excel" class="colour-excel"></b-icon>
              <span style="font-weight: bold"> Descargar Excel </span>
            </button>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
              </p>
              <p>Ninguna Solicitud Registrada.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Util from "../../../util";
import ReporteItemMateriales from "../../../api/modules/ReporteItemMateriales";

export default {
  data() {
    return {
      ordersMaterial: [],
      materiales: [],
      radioStatus: "recep",
      searchOptions: {
        perPage: 10,
        pageNumber: 1,
        sortField: "orderDate",
        sortOrder: "desc",
      },
      defaultSortOrder: "desc",
      defaultOpenedDetails: [1],
      isValidoRecepcionar: true,
    };
  },
  methods: {
    ...mapActions({
      loadOrdersMateriales: "materiales/loadOrdersMateriales",
    }),

    loadNameUserById(idUser) {
      return (
        Util.getUserById(idUser).person.firstName +
        " " +
        Util.getUserById(idUser).person.lastName
      );
    },

    cargarPedidos() {
      this.materiales = [];
      let idAddress = Util.getUser().idAddress;
      let payload = null;

      var paramsArray = [
        `isPageable=${false}`,
        `idAddress=${idAddress}`,
      ];
      const params = paramsArray.join("&");
      payload = {
        context: this,
        idClient: Util.getAuth().idClient,
        params: params,
      };

      this.loadOrdersMateriales(payload)
        .then((data) => {
          this.ordersMaterial = data;
          let orderMaterial = this.ordersMaterial;
          orderMaterial.forEach((item) => {
            let materialesTmp = item.materiales;
            materialesTmp.forEach((m) => {
              m.numberOrder = item.numberOrder;

              this.materiales.push(m);
            });
          });
        })
        .catch((error) => {
          this.orderList = [];
        });
    },

    getClassStatusOrder(value) {
      if (!value) return "";
      if (value === "pen" || value === "envobs" || value === "entobs")
        return "is-warning";
      else if (value === "apr" || value === "env") return "is-info";
      else if (value === "recep") return "is-success";
      else if (value === "can") return "is-danger";
      else return "";
    },

    doExportReportFilesPdf(param) {
      ReporteItemMateriales.dowloadItemMaterialesById(this, {
        idClient: this.getClient.id,
        idMaterial: param.id,
        code: param.code,
      }).then();
    },
  },
  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),
  },
  mounted() {
    this.cargarPedidos();
  },

  created() {},
};
</script>

<style scoped>
.report {
  margin-top: 30px;
}
.center {
  text-align: center;
}
.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}
.break-word {
  word-break: break-all;
}
.colour-pdf {
  color: red;
}
.colour-excel {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/reportes/materiales/ConsultaMateriales.vue